export default __webpack_public_path__ + "static/media/avatar-s1.82e92d3a.png";